const SEARCH_JOB_TYPES = ['googleMapsScraper', 'localHrSearch'];
const ACTIVE_STATUSES = ['queued', 'running'];

export const isRunningSearchJob = (job) =>
	SEARCH_JOB_TYPES.includes(job.jobType) && ACTIVE_STATUSES.includes(job.status);
